import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-2xl text-center" data-id="element-228" data-mp="3f1vm1h65qdez">
      <span className="inline-block rounded-full border border-lime/30 bg-lime/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-lime" data-id="element-229" data-mp="3f36qzkbc9r7o">
        {eyebrow}
      </span>
      <h2 className="mt-4 font-display text-[28px] font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl" data-id="element-230" data-mp="bl5bqq3jle7h">
        {title}
      </h2>
      {subtitle ? <p className="mt-4 text-[15px] leading-relaxed text-slate-400 sm:text-base" data-id="element-231" data-mp="1tisc6h1w8tn">{subtitle}</p> : null}
    </div>;
}